function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { sdkLogger } from '../../logger';
import { ObserverPriority } from './observable.enums';
export var createErrorLogger = function(name, logger) {
    return function(error) {
        logger.error("Error when notifying observers for ".concat(name, ": "), _object_spread_props(_object_spread({}, error), {
            message: "".concat(error.message, " Error in observable: ").concat(name)
        }));
    };
};
export var OBSERVABLE_IGNORE_EVENT = Symbol('OBSERVABLE_IGNORE_EVENT');
var defaultErrorHandler = createErrorLogger('Observable', sdkLogger.withContext('Observable'));
export var Observable = /*#__PURE__*/ function() {
    "use strict";
    function Observable() {
        var _this = this;
        var errorHandler = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultErrorHandler;
        _class_call_check(this, Observable);
        _define_property(this, "errorHandler", void 0);
        _define_property(this, "currentState", void 0);
        _define_property(this, "hasStateBeenInitialised", void 0);
        _define_property(this, "numTimesNotified", void 0);
        _define_property(this, "eventTransformers", void 0);
        _define_property(this, "registeredObservers", void 0);
        _define_property(this, "transformEventState", void 0);
        this.errorHandler = errorHandler;
        this.currentState = null;
        this.hasStateBeenInitialised = false;
        this.numTimesNotified = 0;
        this.eventTransformers = [];
        this.registeredObservers = new Array();
        this.transformEventState = function(newState) {
            var transformedState = newState;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = _this.eventTransformers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var fn = _step.value;
                    if (transformedState === OBSERVABLE_IGNORE_EVENT) {
                        break;
                    }
                    try {
                        var nextState = fn(transformedState);
                        transformedState = nextState;
                    } catch (error) {
                        _this.errorHandler(error);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return transformedState;
        };
    }
    _create_class(Observable, [
        {
            key: "getCurrentState",
            value: function getCurrentState() {
                return this.currentState;
            }
        },
        {
            key: "addTransformer",
            value: function addTransformer(transformingFunction) {
                this.eventTransformers.push(transformingFunction);
            }
        },
        {
            key: "registerObserver",
            value: function registerObserver(observer, owner, config) {
                var _this = this;
                var observerMetadata = this.setupObserverMetadata(config);
                this.addObserverWithPriority({
                    observer: observer,
                    owner: owner,
                    meta: observerMetadata
                });
                if (config === null || config === void 0 ? void 0 : config.renotifyLastEvent) {
                    this.doNotify([
                        {
                            observer: observer,
                            owner: owner,
                            meta: observerMetadata
                        }
                    ], this.currentState);
                }
                return function() {
                    return _this.unregisterObserver(observer);
                };
            }
        },
        {
            key: "addObserverWithPriority",
            value: function addObserverWithPriority(item) {
                for(var i = 0; i < this.registeredObservers.length; i++){
                    // Note: Higher priority means a lower number (e.g. P0 is higher priority than P1)
                    var isHigherPriority = item.meta.priority < this.registeredObservers[i].meta.priority;
                    if (isHigherPriority) {
                        this.registeredObservers.splice(i, 0, item);
                        return;
                    }
                }
                this.registeredObservers.push(item);
            }
        },
        {
            key: "unregisterObserver",
            value: function unregisterObserver(observer) {
                var _this = this;
                this.registeredObservers.forEach(function(item, index) {
                    if (item.observer !== observer) {
                        return;
                    }
                    _this.registeredObservers.splice(index, 1);
                });
            }
        },
        {
            key: "unregisterObservers",
            value: function unregisterObservers(owner) {
                this.registeredObservers = this.registeredObservers.filter(function(item) {
                    return item.owner !== owner;
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.currentState = null;
                this.hasStateBeenInitialised = false;
            }
        },
        {
            key: "getNumTimesNotified",
            value: function getNumTimesNotified() {
                return this.numTimesNotified;
            }
        },
        {
            key: "notifyObservers",
            value: function notifyObservers(newState, currentPosition, absolutePosition) {
                var isNewStateUndefined = typeof newState === 'undefined';
                var isStatelessObservable = typeof this.currentState === 'undefined' && isNewStateUndefined;
                var adaptedState = this.transformEventState(newState);
                if (adaptedState !== OBSERVABLE_IGNORE_EVENT && (isStatelessObservable || this.currentState !== adaptedState)) {
                    this.hasStateBeenInitialised = true;
                    this.currentState = adaptedState;
                    this.numTimesNotified++;
                    this.doNotify(this.registeredObservers, adaptedState, currentPosition, absolutePosition);
                }
                return adaptedState;
            }
        },
        {
            key: "doNotify",
            value: function doNotify(observers, adaptedState, currentPosition, absolutePosition) {
                var _this = this;
                if (!this.hasStateBeenInitialised) {
                    return;
                }
                observers === null || observers === void 0 ? void 0 : observers.forEach(function(item) {
                    try {
                        if (item.meta.hasBeenNotifiedTimes++ > 0 && item.meta.once) {
                            defaultErrorHandler(new Error('Observable has already notified but was configured to notify once.'));
                            return;
                        }
                        if (item.observer.length > 2) {
                            item.observer(adaptedState, currentPosition, absolutePosition);
                        } else if (item.observer.length > 1) {
                            item.observer(adaptedState, currentPosition);
                        } else {
                            item.observer(adaptedState);
                        }
                    } catch (error) {
                        _this.errorHandler(error);
                    }
                });
            }
        },
        {
            key: "setupObserverMetadata",
            value: function setupObserverMetadata(config) {
                var _config_once, _config_priority;
                return {
                    once: (_config_once = config === null || config === void 0 ? void 0 : config.once) !== null && _config_once !== void 0 ? _config_once : false,
                    hasBeenNotifiedTimes: 0,
                    priority: (_config_priority = config === null || config === void 0 ? void 0 : config.priority) !== null && _config_priority !== void 0 ? _config_priority : ObserverPriority.NORMAL
                };
            }
        }
    ]);
    return Observable;
}();

//# sourceMappingURL=observable.js.map